import { GET_USER_OK, GET_USER_ERR } from "./get-user.action";

const InitState = {
  error: null,
  content: null,
};

export default function getUserReducer(state = InitState, action) {
  switch (action.type) {
    case GET_USER_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case GET_USER_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    default:
      return state;
  }
}
